
    <!--
 * 横版-签到领奖
 * @LastEditTime: Fri Apr 04 2025 19:11:27 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_WSHP87"  :style="compData.moduleBgImg ? `background-image: url(${ compData.moduleBgImg })` : `background-color: ${ pageData.bgColor }e5`" :class="[`normal sign-page`,`u_c_WSHP87`]" ><div id="u_c_V3PE88"  :class="[`normal`,`u_c_V3PE88`]" ><div id="u_c_H0MR89"  :style="`background-image:url(${ pageData.titleIcon })`" :class="[`normal`,`u_c_H0MR89`]" ></div><div id="u_c_W1LK90"  v-html="compData.title" :style="`display:${ pageData.isEdit ? 'block' : 'inline' };background-image:linear-gradient(to right, ${ pageData.titleColor1 },${ pageData.titleColor2 })`" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_W1LK90`]" ></div><div id="u_c_O5V991"  :style="`background-image:url(${ pageData.titleIcon })`" :class="[`normal`,`u_c_O5V991`]" ></div></div><div id="u_c_NQH292"  v-html="compData.subTitle" :style="`background-color:${ pageData.btnColor }`" :class="[`normal btn-text`,`u_c_NQH292`]" ></div><div id="u_c_URHE93"  :class="[`normal`,`u_c_URHE93`]" ><span id="u_c_FOYZ94"  :class="[`normal txt`,`u_c_FOYZ94`]" >{{`${ langData.mySignTime }:`}}</span><span id="u_c_RZ4496"  :style="`color:${ pageData.dotHighLightColor }`" :class="[`normal highlight-txt`,`u_c_RZ4496`]" >{{`${ pageData.signTime }`}}</span><span id="u_c_TS4498"  :class="[`normal txt sign-total-day`,`u_c_TS4498`]" >{{`${ langData.day }`}}</span></div><div id="u_c_JZY8100"  :style="compData.signInfo.length <= 5 ? `overflow-x:auto` : ''" :class="[`normal sc`,`u_c_JZY8100`]" ><swiper id="u_c_E7Y720"  :style="`width:${ pageData.isEdit ? compData.signInfo.length > 5 ? compData.signInfo.length * 20 + '%' : '100%' : '' };justify-content:${ compData.signInfo.length > 5 ? 'start' : 'center' }`" :modules="modules" :pagination="({
    el: '.swiper-pagination-sign',
    clickable: true
})" :slides-per-view="compData.signInfo.length >= 5 ? 5 : compData.signInfo.length" :class="[`normal`,`u_c_E7Y720`]" ><template   v-for="(signItem, signIndex) in compData.signInfo" :key="signIndex" :class="[`normal signItem`,`u_c_JDPH21`]" ><swiper-slide id="u_c_41JA22"  :style="`width:${ !pageData.isEdit ? compData.signInfo.length > 5 ? '20%' : 100 / compData.signInfo.length + '%' : '' };justify-content:${ pageData.isEdit ? compData.signInfo.length > 5 ? 'start' : 'center' : 'center' }`" :class="[`normal`,`u_c_41JA22`]" ><div id="u_c_W1ID101"  :data-index="signItem.day" :class="[`normal sign-item btn-light award-btn`,`u_c_W1ID101`]" ><div id="u_c_HWDF102"  :style="signItem.state == 2 || signItem.state == void 0 && signIndex == 0 ? `filter:  brightness(60%)` : ``" :class="[`normal `,`u_c_HWDF102`]" @click="u_c_HWDF102_event_W81W61($event,signIndex)"><div id="u_c_KVPP103"  :class="[`normal`,`u_c_KVPP103`]" ><div id="u_c_MWAA104"  v-html="signItem.day" :class="[`normal sign-day`,`u_c_MWAA104`]" ></div>{{`${ langData.day }`}}</div><div id="u_c_QFJU106"  :style="`background-image:url(${ signItem.pic })`" :class="[({ 'got':     signItem.state == 2 ||    signItem.state == void 0 &&    signIndex == 0 }),`normal sign-img`,`u_c_QFJU106`]" ></div></div><div id="u_c_IJWP107"  v-show="signItem.state == 2 || signItem.state == void 0 && signIndex == 0" :class="[`normal gou`,`u_c_IJWP107`]" ></div></div></swiper-slide></template></swiper><div id="u_c_VQ4531"  :class="[`normal swiper-pagination-sign`,`u_c_VQ4531`]" ><div id="u_c_RPSL32"  v-for="(ppitem, ppindex) in compData.signInfo" :key="ppindex" :style="+ppindex ? '' : `background-color: ${ pageData.dotHighLightColor }`" :class="[`normal swiper-pagination-sign-bullet`,`u_c_RPSL32`]" ></div></div></div><a id="u_c_VLED108" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal  btn-light  sign-award-btn page-common-btn`,`u_c_VLED108`]" @click="u_c_VLED108_event_8J5W26($event)"><div id="u_c_YGOW109"  :class="[`normal page-common-btn`,`u_c_YGOW109`]" >{{`${ langData.getBtn }`}}</div></a></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import { Swiper, SwiperSlide } from "swiper/vue";import { Pagination } from "swiper";import "swiper/css";  import 'swiper/css/pagination';

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const curRouterCompMap = inject("curRouterCompMap",{});
    const COMP_DATA_LANG = {"default":{"signInfo":[{"name":"签到第1天奖励\n签到第1-1个奖励\n签到第1-2个奖励\n签到第1-3个奖励","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733403669711-11.png"},{"name":"签到第2天奖励","day":"2","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1734071813055-74.png"},{"name":"签到第3天个奖励","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1734071813044-4.png"},{"name":"签到第4天奖励","day":"4","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733403669711-11.png"},{"name":"签到第5天奖励","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733403669711-11.png"},{"name":"签到第6天奖励","day":"6","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733403669711-11.png"},{"name":"签到第7天奖励","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1733403669711-11.png"}],"subTitle":`累计签到达到以下次数，可领取活动奖励`,"title":`每日簽到送不停`,"moduleBgImg":``},"en-US":{"signInfo":[{"name":"Optional Ebony Set Armor *1\nSilver Wheat *1\nLife Stone (Intermediate) *3\nGarnet Jewel *80","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421273811082.png"},{"name":"Optional Ebony Set Armor *1\nScallop Flesh *1\nBlood Castle Entry Ticket *2\nJewel of Chaos *30","day":"2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421210719421.png"},{"name":"Optional Ebony Set Armor *1\nSaint's Mark lv.3 *2\nArena Challenge Ticket *2\nRefining Crystal *40 ","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421205701892.png"},{"name":"Optional Ebony Set Armor *1\nChampion Emerald *1\nHourglass *1\nJewel of Life *5","day":"4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421246753685.png"},{"name":"Optional Ebony Set Armor *1\nAdvanced Benediction Seal *1\nActive Holy Water *1\nGarnet Jewel *120","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421278162925.png"},{"name":"Ebony Set Main/Off-Hand *1\nBurning Obsidian *1\nIcaria Realm Entry Token *2\nJewel of Moonlight*8","day":"6","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421267096401.png"},{"name":"Ebony Set Main/Off-Hand *1\nEagle's Cookie *1\nLife Steal Sacrament(Advanced) *3\nJewel of Life *10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421236794746.png"}],"subTitle":`Log in consecutively on PC and enter the server during the event period to claim corresponding rewards for the number of days you've logged in.`,"title":`PC Login Rewards: Fashion`,"moduleBgImg":``},"th-TH":{"signInfo":[{"name":"เลือกไอเทมป้องกันชุดทองดำ*1\nข้าวสาลีเงิน*1\nศาสตราวุธ HP(ขั้นกลาง)*3\nอัญมณีแต้ม*80","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421273811082.png"},{"name":"เลือกไอเทมป้องกันชุดทองดำ*1\nเนื้อหอยเชลล์*1\nป้ายท้าทายปราสาทโลหิต*2\nอัญมณีมายา*30","day":"2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421210719421.png"},{"name":"เลือกไอเทมป้องกันชุดทองดำ*1\nลายนักบุญlv.3*2\nป้ายท้าทายอารีน่า*2\nคริสตัลสกัด*40","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421205701892.png"},{"name":"เลือกไอเทมป้องกันชุดทองดำ*1\nหยกผู้กล้า*1\nนาฬิกาทรายต้องมนตร์*1\nอัญมณีชีวิต*5","day":"4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421246753685.png"},{"name":"เลือกไอเทมป้องกันชุดทองดำ*1\nตราอวยพรขั้นสูง*1\nน้ำทิพย์แอคทีฟ*1\nอัญมณีแต้ม*120","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421278162925.png"},{"name":"ชุดทองดำมือหลัก/รอง*1\nหินเผาไหม้*1\nป้ายท้าทายแดนมายานภา*2\nอัญมณีจันทร์*8","day":"6","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421267096401.png"},{"name":"ชุดทองดำมือหลัก/รอง*1\nบิสกิตอินทรีสวรรค์*1\nหินไอเทมศักดิ์สิทธิ์ดื่มเลือด(ขั้นสูง)*3\nอัญมณีชีวิต*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421236794746.png"}],"subTitle":`ช่วงกิจกรรม ล็อกอิน PC ต่อเนื่องพร้อมเข้าเซิร์ฟถึงจำนวนวันที่กำหนด จะได้รับรางวัลสอดคล้อง;`,"title":`เช็คอิน PC แจกชุดแฟชั่น`,"moduleBgImg":``},"ru-RU":{"signInfo":[{"name":"Эбоновый набор доспехов *1\nСеребряная пшеница *1\nКамень жизни (усиленный) *3\nГранатовый самоцвет *80","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421273811082.png"},{"name":"Эбоновый набор доспехов *1\nМякоть гребешка *1\nБилет в Кровавый Замок *2\nСамоцвет Хаоса *30","day":"2","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421210719421.png"},{"name":"Набор доспехов черного золота *1\nЗнак святого ур.3 *2\nБилет вызова арены *2\nКристалл закалки *40","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421205701892.png"},{"name":"Эбоновый набор доспехов *1\nИзумруд чемпиона *1\nПесочные часы *1\nСамоцвет жизни *5","day":"4","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421246753685.png"},{"name":"Эбоновый набор доспехов *1\nУсиленная печать благословения *1\nАктивная святая вода *1\nГранатовый самоцвет *120","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421278162925.png"},{"name":"Эбоновый набор основная/вторая рука *1\nГорящий обсидиан *1\nБилет в Царство икарии *2\nСамоцвет лунного света*8","day":"6","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421267096401.png"},{"name":"Эбоновый набор основная/вторая рука *1 Печенье орла *1\nСакрамент вампиризма (усиленный) *3\nСамоцвет здоровья *10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2025/04/174350421236794746.png"}],"subTitle":`Входите в игру на ПК и посещайте сервер в период проведения события, чтобы получить награды за количество дней выполнения авторизации.`,"title":`Награды за вход на ПК: Наряды`,"moduleBgImg":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '签到领奖';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const listData = inject("listData", {})
const giftInfo = inject("giftInfo", {})

const curPlatform = pagePlatform

const init = () => {
  compData.signInfo.forEach((item) => {
    item.state = 0
  })
}

watch(
  () => listData,
  (value) => {
    if (value && value.signList) {
      let confList = _.cloneDeep(compData.signInfo)
      compData.signInfo = []
      value.signList.forEach((item, index) => {
        if (confList[index]) {
          compData.signInfo.push({
            pic: confList[index].pic,
            state: item.send_status,
            day: item.sign_day,
            name: confList[index].name
          })
        }
      })
      giftInfo.signInAward = compData.signInfo
    }
  }, {
    deep: true
  }
)

init()

const canClickSign = ref(true)
const signDay = async (day, index) => {

  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'signInAward'), {
    params: JSON.stringify({
      sign_day: +day,
      language: curLang
    }),
  })
  if (res.result == 1) {
    compData.signInfo[index].state = 2;
    let curGiftName = res.data.send_type == 'sendSerial' ? res.data.send_value : compData.signInfo[index].name;
    showGetSucc(res.data.send_type, compData.signInfo[index].pic, curGiftName)
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
  return res.result == 1
};
      // 签到item的click事件
      const u_c_HWDF102_event_W81W61= async (e,index)=>{
        try {pageData.seeGift = [compData.signInfo[index]]
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 签到可领按钮的click事件
      const u_c_VLED108_event_8J5W26= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (!canClickSign.value) return;
canClickSign.value = false;
window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: `领取签到奖励`,
  gameId: pageData.gameId,
  aid: pageData.pageId
});
let curIndex = compData.signInfo.findIndex(item => item.state == 1);
if (~curIndex) {
  await signDay(compData.signInfo[curIndex].day, curIndex);
} else {
  let finishIndex = compData.signInfo.findIndex(item => item.state == 2);
  showTips(
    getLangTxt(
      finishIndex == compData.signInfo.length - 1 ? '-20001' : '-10010',
      getLangTxt('common')
    ),
    ''
  );
}
canClickSign.value = true;} catch (error) {console.log(error)}
      };const modules = computed(()=> [Pagination])
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_WSHP87.normal{
position:relative;
width:100.00vw;
height:fit-content;
overflow:hidden;
font-size:0;
margin:auto;
padding:0 1.56vw 5.21vw 1.56vw;
box-sizing:border-box;
margin-top:-0.05vw;
background:no-repeat top;
background-size:cover;

}
}.default{
.u_c_V3PE88.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
margin-top:1.56vw;

}
}.default{
.u_c_H0MR89.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-right:1.56vw;

}
}.default{
.u_c_W1LK90.normal{
position:relative;
width:fit-content;
height:5.52vw;
margin:0;
margin-top:0;
font-size:3.13vw;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;
-webkit-background-clip:text;
background-clip:text;
color:transparent;
max-width:65.36vw;

}

.u_c_W1LK90.normal.text{
width:fit-content;
height:auto;

}
}.default{
.u_c_O5V991.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-left:1.56vw;
transform:rotate(180deg);

}
}.default{
.u_c_NQH292.normal{
position:relative;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.67vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
width:fit-content;
margin:0 auto;
margin-top:2.14vw;
padding:1.04vw 1.56vw;
border-radius:0.73vw;
max-width:65.36vw;

}
}.default{
.u_c_URHE93.normal{
position:relative;
text-align:center;
margin-top:0.52vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_URHE93.normal .txt{
font-size:1.67vw;

}
}.default{
.u_c_FOYZ94.normal{
position:relative;

}
}.default{
.u_c_RZ4496.normal{
position:relative;
margin:auto 1.04vw;

}
}.default{
.u_c_TS4498.normal{
position:relative;

}
}.default{
.u_c_JZY8100.normal{
position:relative;
width:65.26vw;
margin:auto;
margin-top:3.33vw;
text-align:center;
 white-space:nowrap;
overflow:hidden;

}

.u_c_JZY8100.normal .sign-item{
display:inline-block;

}

.u_c_JZY8100.normal .sign-img{
max-width:90%;

}

.u_c_JZY8100.normal::-webkit-scrollbar{
width:0.83vw;
height:0.83vw;
border-radius:0.57vw;

}

.u_c_JZY8100.normal::-webkit-scrollbar-thumb{
background:#676f6e;
border-radius:0.57vw;

}

.u_c_JZY8100.normal::-webkit-scrollbar-track{
background:#25302f;
border-radius:0.57vw;

}

.u_c_JZY8100.normal scrollbar {
width:0.94vw;
height:0.94vw;
-moz-appearance:none;

}

.u_c_JZY8100.normal scrollbar-thumb{
background:#676f6e;
border-radius:0.57vw;

}

.u_c_JZY8100.normal scrollbar-track{
background:#25302f;
border-radius:0.57vw;

}
}.default{
.u_c_E7Y720.normal{
position:relative;
width:100%;
margin:auto;
display:flex;
white-space:nowrap;
overflow:hidden;
gap:1.82vw;
flex-wrap:nowrap;
padding-bottom:0.52vw;
justify-content:start;
z-index:7;

}
}.default{
.u_c_JDPH21.normal{
position:relative;

}
}.default{
.u_c_41JA22.normal{
position:relative;
display:flex;

}
}.default{
.u_c_W1ID101.normal{
position:relative;
width:fit-content;
height:fit-content;

}
}.default{
.u_c_HWDF102.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742907473538-82.png);
background-size:contain;
width:11.30vw;
height:17.40vw;

}
}.default{
.u_c_KVPP103.normal{
position:absolute;
font-size:1.82vw;
color:#FFFFFF;
text-align:center;
margin:0 auto;
bottom:1.04vw;
display:flex;
align-items:center;
justify-content:center;
width:100%;

}
}.default{
.u_c_MWAA104.normal{
position:relative;

}
}.default{
.u_c_QFJU106.normal{
position:absolute;
width:7.14vw;
height:7.14vw;
background:no-repeat center;
background-size:contain;
margin:auto;
top:50%;
left:50%;
transform:translate(-50%, -50%);
margin-top:-0.52vw;

}
}.default{
.u_c_IJWP107.normal{
position:absolute;
width:7.40vw;
height:7.40vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735653041622-98.png);
top:50%;
left:50%;
transform:translate(-50%, -50%);
margin-top:-0.52vw;

}
}.default{
.u_c_VQ4531.normal{
position:relative;
margin:auto;
margin-top:1.04vw;
display:flex;
justify-content:center;
width:100%;
height:1.51vw;

}

.u_c_VQ4531.normal .swiper-pagination-sign-bullet,.normal ::v-deep(.swiper-pagination-bullet){
width:1.51vw;
height:1.51vw;
background-color:#ffffff;
margin:auto 1.04vw;
border-radius:5.16vw;
opacity:1;

}

.u_c_VQ4531.normal .swiper-pagination-sign-bullet-active,.normal ::v-deep(.swiper-pagination-bullet-active){
background-color:#e8e078;

}
}.default{
.u_c_RPSL32.normal{
position:relative;

}
}.default{
.u_c_VLED108.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:15.73vw;
height:5.36vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:3.13vw;

}
}.default{
.u_c_YGOW109.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.14vw;
font-weight:bold;

}
}.en-US{
.u_c_WSHP87.normal{
position:relative;
width:100.00vw;
height:fit-content;
overflow:hidden;
font-size:0;
margin:auto;
padding:0 1.56vw 5.21vw 1.56vw;
box-sizing:border-box;
margin-top:-0.05vw;
background:no-repeat top;
background-size:cover;

}
}.en-US{
.u_c_V3PE88.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
margin-top:1.56vw;

}
}.en-US{
.u_c_H0MR89.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-right:1.56vw;

}
}.en-US{
.u_c_W1LK90.normal{
position:relative;
width:fit-content;
height:5.52vw;
margin:0;
margin-top:0;
font-size:3.13vw;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;
-webkit-background-clip:text;
background-clip:text;
color:transparent;
max-width:65.36vw;

}

.u_c_W1LK90.normal.text{
width:fit-content;
height:auto;

}
}.en-US{
.u_c_O5V991.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-left:1.56vw;
transform:rotate(180deg);

}
}.en-US{
.u_c_NQH292.normal{
position:relative;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.67vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
width:fit-content;
margin:0 auto;
margin-top:2.14vw;
padding:1.04vw 1.56vw;
border-radius:0.73vw;
max-width:65.36vw;

}
}.en-US{
.u_c_URHE93.normal{
position:relative;
text-align:center;
margin-top:0.52vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_URHE93.normal .txt{
font-size:1.67vw;

}
}.en-US{
.u_c_FOYZ94.normal{
position:relative;

}
}.en-US{
.u_c_RZ4496.normal{
position:relative;
margin:auto 1.04vw;

}
}.en-US{
.u_c_TS4498.normal{
position:relative;

}
}.en-US{
.u_c_JZY8100.normal{
position:relative;
width:65.26vw;
margin:auto;
margin-top:3.33vw;
text-align:center;
 white-space:nowrap;
overflow:hidden;

}

.u_c_JZY8100.normal .sign-item{
display:inline-block;

}

.u_c_JZY8100.normal .sign-img{
max-width:90%;

}

.u_c_JZY8100.normal::-webkit-scrollbar{
width:0.83vw;
height:0.83vw;
border-radius:0.57vw;

}

.u_c_JZY8100.normal::-webkit-scrollbar-thumb{
background:#676f6e;
border-radius:0.57vw;

}

.u_c_JZY8100.normal::-webkit-scrollbar-track{
background:#25302f;
border-radius:0.57vw;

}

.u_c_JZY8100.normal scrollbar {
width:0.94vw;
height:0.94vw;
-moz-appearance:none;

}

.u_c_JZY8100.normal scrollbar-thumb{
background:#676f6e;
border-radius:0.57vw;

}

.u_c_JZY8100.normal scrollbar-track{
background:#25302f;
border-radius:0.57vw;

}
}.en-US{
.u_c_E7Y720.normal{
position:relative;
width:100%;
margin:auto;
display:flex;
white-space:nowrap;
overflow:hidden;
gap:1.82vw;
flex-wrap:nowrap;
padding-bottom:0.52vw;
justify-content:start;
z-index:7;

}
}.en-US{
.u_c_JDPH21.normal{
position:relative;

}
}.en-US{
.u_c_41JA22.normal{
position:relative;
display:flex;

}
}.en-US{
.u_c_W1ID101.normal{
position:relative;
width:fit-content;
height:fit-content;

}
}.en-US{
.u_c_HWDF102.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742907473538-82.png);
background-size:contain;
width:11.30vw;
height:17.40vw;

}
}.en-US{
.u_c_KVPP103.normal{
position:absolute;
font-size:1.82vw;
color:#FFFFFF;
text-align:center;
margin:0 auto;
bottom:1.04vw;
display:flex;
align-items:center;
justify-content:center;
width:100%;

}
}.en-US{
.u_c_MWAA104.normal{
position:relative;

}
}.en-US{
.u_c_QFJU106.normal{
position:absolute;
width:7.14vw;
height:7.14vw;
background:no-repeat center;
background-size:contain;
margin:auto;
top:50%;
left:50%;
transform:translate(-50%, -50%);
margin-top:-0.52vw;

}
}.en-US{
.u_c_IJWP107.normal{
position:absolute;
width:7.40vw;
height:7.40vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735653041622-98.png);
top:50%;
left:50%;
transform:translate(-50%, -50%);
margin-top:-0.52vw;

}
}.en-US{
.u_c_VQ4531.normal{
position:relative;
margin:auto;
margin-top:1.04vw;
display:flex;
justify-content:center;
width:100%;
height:1.51vw;

}

.u_c_VQ4531.normal .swiper-pagination-sign-bullet,.normal ::v-deep(.swiper-pagination-bullet){
width:1.51vw;
height:1.51vw;
background-color:#ffffff;
margin:auto 1.04vw;
border-radius:5.16vw;
opacity:1;

}

.u_c_VQ4531.normal .swiper-pagination-sign-bullet-active,.normal ::v-deep(.swiper-pagination-bullet-active){
background-color:#e8e078;

}
}.en-US{
.u_c_RPSL32.normal{
position:relative;

}
}.en-US{
.u_c_VLED108.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:15.73vw;
height:5.36vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:3.13vw;

}
}.en-US{
.u_c_YGOW109.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.14vw;
font-weight:bold;

}
}.th-TH{
.u_c_WSHP87.normal{
position:relative;
width:100.00vw;
height:fit-content;
overflow:hidden;
font-size:0;
margin:auto;
padding:0 1.56vw 5.21vw 1.56vw;
box-sizing:border-box;
margin-top:-0.05vw;
background:no-repeat top;
background-size:cover;

}
}.th-TH{
.u_c_V3PE88.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
margin-top:1.56vw;

}
}.th-TH{
.u_c_H0MR89.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-right:1.56vw;

}
}.th-TH{
.u_c_W1LK90.normal{
position:relative;
width:fit-content;
height:5.52vw;
margin:0;
margin-top:0;
font-size:3.13vw;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;
-webkit-background-clip:text;
background-clip:text;
color:transparent;
max-width:65.36vw;

}

.u_c_W1LK90.normal.text{
width:fit-content;
height:auto;

}
}.th-TH{
.u_c_O5V991.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-left:1.56vw;
transform:rotate(180deg);

}
}.th-TH{
.u_c_NQH292.normal{
position:relative;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.67vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
width:fit-content;
margin:0 auto;
margin-top:2.14vw;
padding:1.04vw 1.56vw;
border-radius:0.73vw;
max-width:65.36vw;

}
}.th-TH{
.u_c_URHE93.normal{
position:relative;
text-align:center;
margin-top:0.52vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_URHE93.normal .txt{
font-size:1.67vw;

}
}.th-TH{
.u_c_FOYZ94.normal{
position:relative;

}
}.th-TH{
.u_c_RZ4496.normal{
position:relative;
margin:auto 1.04vw;

}
}.th-TH{
.u_c_TS4498.normal{
position:relative;

}
}.th-TH{
.u_c_JZY8100.normal{
position:relative;
width:65.26vw;
margin:auto;
margin-top:3.33vw;
text-align:center;
 white-space:nowrap;
overflow:hidden;

}

.u_c_JZY8100.normal .sign-item{
display:inline-block;

}

.u_c_JZY8100.normal .sign-img{
max-width:90%;

}

.u_c_JZY8100.normal::-webkit-scrollbar{
width:0.83vw;
height:0.83vw;
border-radius:0.57vw;

}

.u_c_JZY8100.normal::-webkit-scrollbar-thumb{
background:#676f6e;
border-radius:0.57vw;

}

.u_c_JZY8100.normal::-webkit-scrollbar-track{
background:#25302f;
border-radius:0.57vw;

}

.u_c_JZY8100.normal scrollbar {
width:0.94vw;
height:0.94vw;
-moz-appearance:none;

}

.u_c_JZY8100.normal scrollbar-thumb{
background:#676f6e;
border-radius:0.57vw;

}

.u_c_JZY8100.normal scrollbar-track{
background:#25302f;
border-radius:0.57vw;

}
}.th-TH{
.u_c_E7Y720.normal{
position:relative;
width:100%;
margin:auto;
display:flex;
white-space:nowrap;
overflow:hidden;
gap:1.82vw;
flex-wrap:nowrap;
padding-bottom:0.52vw;
justify-content:start;
z-index:7;

}
}.th-TH{
.u_c_JDPH21.normal{
position:relative;

}
}.th-TH{
.u_c_41JA22.normal{
position:relative;
display:flex;

}
}.th-TH{
.u_c_W1ID101.normal{
position:relative;
width:fit-content;
height:fit-content;

}
}.th-TH{
.u_c_HWDF102.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742907473538-82.png);
background-size:contain;
width:11.30vw;
height:17.40vw;

}
}.th-TH{
.u_c_KVPP103.normal{
position:absolute;
font-size:1.82vw;
color:#FFFFFF;
text-align:center;
margin:0 auto;
bottom:1.04vw;
display:flex;
align-items:center;
justify-content:center;
width:100%;

}
}.th-TH{
.u_c_MWAA104.normal{
position:relative;

}
}.th-TH{
.u_c_QFJU106.normal{
position:absolute;
width:7.14vw;
height:7.14vw;
background:no-repeat center;
background-size:contain;
margin:auto;
top:50%;
left:50%;
transform:translate(-50%, -50%);
margin-top:-0.52vw;

}
}.th-TH{
.u_c_IJWP107.normal{
position:absolute;
width:7.40vw;
height:7.40vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735653041622-98.png);
top:50%;
left:50%;
transform:translate(-50%, -50%);
margin-top:-0.52vw;

}
}.th-TH{
.u_c_VQ4531.normal{
position:relative;
margin:auto;
margin-top:1.04vw;
display:flex;
justify-content:center;
width:100%;
height:1.51vw;

}

.u_c_VQ4531.normal .swiper-pagination-sign-bullet,.normal ::v-deep(.swiper-pagination-bullet){
width:1.51vw;
height:1.51vw;
background-color:#ffffff;
margin:auto 1.04vw;
border-radius:5.16vw;
opacity:1;

}

.u_c_VQ4531.normal .swiper-pagination-sign-bullet-active,.normal ::v-deep(.swiper-pagination-bullet-active){
background-color:#e8e078;

}
}.th-TH{
.u_c_RPSL32.normal{
position:relative;

}
}.th-TH{
.u_c_VLED108.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:15.73vw;
height:5.36vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:3.13vw;

}
}.th-TH{
.u_c_YGOW109.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.14vw;
font-weight:bold;

}
}.ru-RU{
.u_c_WSHP87.normal{
position:relative;
width:100.00vw;
height:fit-content;
overflow:hidden;
font-size:0;
margin:auto;
padding:0 1.56vw 5.21vw 1.56vw;
box-sizing:border-box;
margin-top:-0.05vw;
background:no-repeat top;
background-size:cover;

}
}.ru-RU{
.u_c_V3PE88.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
margin-top:1.56vw;

}
}.ru-RU{
.u_c_H0MR89.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-right:1.56vw;

}
}.ru-RU{
.u_c_W1LK90.normal{
position:relative;
width:fit-content;
height:5.52vw;
margin:0;
margin-top:0;
font-size:3.13vw;
color:#fff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;
-webkit-background-clip:text;
background-clip:text;
color:transparent;
max-width:65.36vw;

}

.u_c_W1LK90.normal.text{
width:fit-content;
height:auto;

}
}.ru-RU{
.u_c_O5V991.normal{
position:relative;
background:no-repeat center;
background-size:contain;
width:1.82vw;
height:1.20vw;
margin-left:1.56vw;
transform:rotate(180deg);

}
}.ru-RU{
.u_c_NQH292.normal{
position:relative;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.67vw;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
width:fit-content;
margin:0 auto;
margin-top:2.14vw;
padding:1.04vw 1.56vw;
border-radius:0.73vw;
max-width:65.36vw;

}
}.ru-RU{
.u_c_URHE93.normal{
position:relative;
text-align:center;
margin-top:0.52vw;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_URHE93.normal .txt{
font-size:1.67vw;

}
}.ru-RU{
.u_c_FOYZ94.normal{
position:relative;

}
}.ru-RU{
.u_c_RZ4496.normal{
position:relative;
margin:auto 1.04vw;

}
}.ru-RU{
.u_c_TS4498.normal{
position:relative;

}
}.ru-RU{
.u_c_JZY8100.normal{
position:relative;
width:65.26vw;
margin:auto;
margin-top:3.33vw;
text-align:center;
 white-space:nowrap;
overflow:hidden;

}

.u_c_JZY8100.normal .sign-item{
display:inline-block;

}

.u_c_JZY8100.normal .sign-img{
max-width:90%;

}

.u_c_JZY8100.normal::-webkit-scrollbar{
width:0.83vw;
height:0.83vw;
border-radius:0.57vw;

}

.u_c_JZY8100.normal::-webkit-scrollbar-thumb{
background:#676f6e;
border-radius:0.57vw;

}

.u_c_JZY8100.normal::-webkit-scrollbar-track{
background:#25302f;
border-radius:0.57vw;

}

.u_c_JZY8100.normal scrollbar {
width:0.94vw;
height:0.94vw;
-moz-appearance:none;

}

.u_c_JZY8100.normal scrollbar-thumb{
background:#676f6e;
border-radius:0.57vw;

}

.u_c_JZY8100.normal scrollbar-track{
background:#25302f;
border-radius:0.57vw;

}
}.ru-RU{
.u_c_E7Y720.normal{
position:relative;
width:100%;
margin:auto;
display:flex;
white-space:nowrap;
overflow:hidden;
gap:1.82vw;
flex-wrap:nowrap;
padding-bottom:0.52vw;
justify-content:start;
z-index:7;

}
}.ru-RU{
.u_c_JDPH21.normal{
position:relative;

}
}.ru-RU{
.u_c_41JA22.normal{
position:relative;
display:flex;

}
}.ru-RU{
.u_c_W1ID101.normal{
position:relative;
width:fit-content;
height:fit-content;

}
}.ru-RU{
.u_c_HWDF102.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742907473538-82.png);
background-size:contain;
width:11.30vw;
height:17.40vw;

}
}.ru-RU{
.u_c_KVPP103.normal{
position:absolute;
font-size:1.82vw;
color:#FFFFFF;
text-align:center;
margin:0 auto;
bottom:1.04vw;
display:flex;
align-items:center;
justify-content:center;
width:100%;

}
}.ru-RU{
.u_c_MWAA104.normal{
position:relative;

}
}.ru-RU{
.u_c_QFJU106.normal{
position:absolute;
width:7.14vw;
height:7.14vw;
background:no-repeat center;
background-size:contain;
margin:auto;
top:50%;
left:50%;
transform:translate(-50%, -50%);
margin-top:-0.52vw;

}
}.ru-RU{
.u_c_IJWP107.normal{
position:absolute;
width:7.40vw;
height:7.40vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/12/1735653041622-98.png);
top:50%;
left:50%;
transform:translate(-50%, -50%);
margin-top:-0.52vw;

}
}.ru-RU{
.u_c_VQ4531.normal{
position:relative;
margin:auto;
margin-top:1.04vw;
display:flex;
justify-content:center;
width:100%;
height:1.51vw;

}

.u_c_VQ4531.normal .swiper-pagination-sign-bullet,.normal ::v-deep(.swiper-pagination-bullet){
width:1.51vw;
height:1.51vw;
background-color:#ffffff;
margin:auto 1.04vw;
border-radius:5.16vw;
opacity:1;

}

.u_c_VQ4531.normal .swiper-pagination-sign-bullet-active,.normal ::v-deep(.swiper-pagination-bullet-active){
background-color:#e8e078;

}
}.ru-RU{
.u_c_RPSL32.normal{
position:relative;

}
}.ru-RU{
.u_c_VLED108.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:15.73vw;
height:5.36vw;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:3.13vw;

}
}.ru-RU{
.u_c_YGOW109.normal{
position:relative;
font-size:2.40vw;
color:white;
text-align:center;
margin-top:2.14vw;
font-weight:bold;

}
}
</style>
